<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-08-28 18:15:15
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-11-15 14:15:56
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/purchaseApplyTrack/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="purchase-apply-track">
    <orderItem />
  </div>
</template>

<script>
import orderItem from './components/orderItemList.vue';

export default {
  name: 'Index',
  components: {
    orderItem,
  },
};
</script>

<style scoped lang="scss"></style>
